export const HOSPITAL = {
  name: "김포우리병원",
  nameEn: "GIMPO WOORI HOSPITAL",
  short: "GWH+",
  slogan: "지역과 함께, 환자 중심의 신뢰받는 종합병원",
  intro:
    "의료법인 우리의료재단 김포우리병원은 진료·검진·전문센터를 아우르는 종합병원입니다. 여성의학센터, 건강증진센터, 응급의료센터를 통해 지역 주민의 건강을 책임집니다.",
  address: "경기도 김포시 감암로 11 (걸포동)",
  phone: "031-999-1000",
  counsel: "1551-7575",
  checkup: "1551-8275",
  emergency: "031-999-1119",
  email: "info@gwhospital.co.kr",
  hours: "평일 09:00 - 17:00 · 토요일 09:00 - 13:00",
  emergencyNote: "응급의료센터 24시간 운영",
};

export const NAV = [
  { id: "guide", label: "진료안내" },
  { id: "centers", label: "진료과·센터" },
  { id: "checkup", label: "건강증진센터" },
  { id: "doctors", label: "의료진" },
  { id: "stories", label: "우리 이야기" },
  { id: "about", label: "병원소개" },
];

export const HERO_SLIDES = [
  {
    tag: "종합병원",
    title: "어린이들의 사랑이 머무는 풍경",
    desc: "가족의 건강을 지키는 김포우리병원이 함께합니다.",
    tone: "linear-gradient(135deg, #0c4a6e 0%, #0891b2 55%, #22d3ee 100%)",
  },
  {
    tag: "여성의학센터",
    title: "여성 질환 통합 진료",
    desc: "갑상선암·유방암·부인암 — 다학제 협진으로 맞춤 치료를 제공합니다.",
    tone: "linear-gradient(135deg, #831843 0%, #be185d 50%, #f472b6 100%)",
  },
  {
    tag: "건강증진센터",
    title: "맞춤형 건강검진",
    desc: "기업·개인 검진부터 결과 상담까지 원스톱으로 안내합니다.",
    tone: "linear-gradient(135deg, #14532d 0%, #15803d 50%, #4ade80 100%)",
  },
];

export const QUICK = [
  { id: "booking", label: "진료 예약", icon: "calendar", target: "booking" },
  { id: "doctors", label: "의료진 찾기", icon: "user", target: "doctors" },
  { id: "checkup", label: "검진 예약", icon: "clipboard", target: "checkup" },
  { id: "emergency", label: "응급 안내", icon: "phone", target: "tel:031-999-1119" },
];

export const STATS = [
  { value: "종합", label: "병원 등급" },
  { value: "24h", label: "응급의료센터" },
  { value: "10+", label: "전문 진료센터" },
  { value: "1:1", label: "맞춤 검진 상담" },
];

export const CENTERS = [
  {
    name: "여성의학센터",
    desc: "갑상선암·유방암·부인암 등 여성 질환 통합 진료",
    tone: "#fdf2f8",
    accent: "#be185d",
  },
  {
    name: "건강증진센터",
    desc: "기업·개인 맞춤 건강검진 및 결과 상담",
    tone: "#ecfdf5",
    accent: "#15803d",
  },
  {
    name: "내분비·당뇨센터",
    desc: "당뇨·갑상선·대사질환 전문 관리",
    tone: "#eff6ff",
    accent: "#2563eb",
  },
  {
    name: "응급의료센터",
    desc: "365일 24시간 응급 진료 체계",
    tone: "#fef2f2",
    accent: "#dc2626",
  },
];

export const DEPARTMENTS = [
  "내과", "외과", "정형외과", "신경외과", "산부인과", "소아청소년과",
  "영상의학과", "마취통증의학과", "진단검사의학과", "응급의학과",
];

export const DOCTORS = [
  { name: "김○○", dept: "여성의학센터", title: "센터장" },
  { name: "이○○", dept: "내분비·당뇨센터", title: "센터장" },
  { name: "박○○", dept: "정형외과", title: "전문의" },
  { name: "최○○", dept: "소아청소년과", title: "전문의" },
];

export const STORIES = [
  {
    category: "병원소식",
    title: "김포시보훈단체협의회 기부금 1,000만원 전달",
    date: "2026.06.04",
    summary: "호국보훈의 달을 맞아 지역 사회와 함께하는 나눔을 실천했습니다.",
  },
  {
    category: "건강칼럼",
    title: "아동성장, 우리아이 단계별 성장과정을 아시나요?",
    date: "2026.05.28",
    summary: "소아청소년과 전문의가 알려드리는 성장 발달 체크리스트.",
  },
  {
    category: "건강칼럼",
    title: "유방 혹, 빠른 검사가 필요한 이유",
    date: "2026.05.20",
    summary: "여성의학센터에서 안내하는 유방 질환 조기 발견의 중요성.",
  },
  {
    category: "닥터 Who",
    title: "의료진의 감성 스토리 — 지역을 지키는 마음",
    date: "2026.05.12",
    summary: "김포우리병원 의료진이 전하는 진료 이야기.",
  },
];

export const PRESS = [
  "[한국경제] 김포우리병원, 김포시보훈단체협의회 기부",
  "[경기신문] 임상의학연구소, 대규모 1상·생동성 시험",
  "[국민일보] 내분비·당뇨센터 원종철 센터장 인터뷰",
];

export const CHECKUP_PACKAGES = [
  { name: "기본 건강검진", price: "35만원~", items: ["기초 혈액", "흉부 X-ray", "복부 초음파"] },
  { name: "직장인 맞춤", price: "55만원~", items: ["심혈관", "간·신장", "갑상선"] },
  { name: "프리미엄 정밀", price: "89만원~", items: ["MRI 선택", "암 표지자", "1:1 결과 상담"] },
];

export const TIME_SLOTS = [
  "10:00 - 11:00", "11:00 - 12:00", "14:00 - 15:00", "15:00 - 16:00", "16:00 - 17:00",
];
